import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { getInfo } from '@/api/user'
import { goLoginPage } from './utils'
import { LOGIN_URL } from './constances/server'
import Cookies from 'js-cookie'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist 白名单 '/dashboard',

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  if (to.query.platform_access_token) {
    // 检测到地址带上了platform_access_token , 总台传过来的参数， 如果总台规则改变则这边同步改变
    // setToken(to.query.platform_access_token)
    Cookies.remove('redirect', { path: '/' })
    await store.dispatch('user/setToken', to.query.platform_access_token)
  }

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken() || ''

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo

      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        // console.log(212)
        if (hasToken !== 'static') {
          getInfo().then(res => {
            store.commit('user/SET_USER_INFO', {
              name: res.data.name,
              code: res.data.customer_number,
              role_id: res.data.role_id,
              role_ids: res.data.role_ids
            })
          })
        }

        next()
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          const { roles } = await store.dispatch('user/getInfo')

          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', roles)

          // dynamically add accessible routes
          router.addRoutes(accessRoutes)

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({ ...to, replace: true })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          // next(`/login?redirect=${to.path}`)
          if (LOGIN_URL.startsWith('/')) {
            next(LOGIN_URL)
          } else {
            goLoginPage()
          }
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      if (LOGIN_URL.startsWith('/')) {
        next(LOGIN_URL)
      } else {
        goLoginPage()
      }
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
